import type { StripeApi } from '@/features/billing/api/billing-api'
import type { CheckoutLinkResource } from '@/features/billing/api/resources/checkout-link'
import type { CheckoutLink } from './CheckoutLink'

/**
 * External Checkout Store.
 */
export class ExternalCheckoutStore {
  constructor(private readonly _api: StripeApi) {}

  async generateCheckoutLink(jobId: string): Promise<CheckoutLink> {
    const resource = await this._api.generateCheckoutLink(jobId)
    return mapCheckoutLinkResourceToCheckoutLink(resource)
  }
}

function mapCheckoutLinkResourceToCheckoutLink(
  resource: CheckoutLinkResource,
): CheckoutLink {
  return {
    id: resource.id,
    url: resource.url,
  }
}
